import { Controller } from 'react-hook-form'
import { Cascader } from 'rsuite'
import classNames from 'classnames'

export default function EditCascaderCell({
  id,
  rowData,
  dataKey,
  items = [],
  disabledItemValues = [],
  error,
  register,
  control,
  isEdit,
  placeholder,
  rules,
  onChange = () => {},
  ...props
}) {
  const editing = rowData.status === 'EDIT' || isEdit
  const _id = id || rowData.id
  return (
    <span {...props} className={editing ? 'table-content-editing' : ''}>
      {editing ? (
        <>
          <Controller
            name={_id}
            control={control}
            defaultValue={rowData[dataKey]}
            rules={rules}
            render={(props) => {
              return (
                <Cascader
                  className={classNames(error && 'is-error')}
                  size="lg"
                  block
                  menuWidth={220}
                  data={items}
                  disabledItemValues={disabledItemValues}
                  value={props.value}
                  onChange={(value) => {
                    props.onChange(value)
                    onChange()
                  }}
                  placeholder={placeholder}
                ></Cascader>
              )
            }}
          />
        </>
      ) : (
        <span>{rowData[dataKey]}</span>
      )}
    </span>
  )
}
